import React from 'react';
import Styles from './styles.module.scss';
import Title from '../TItle';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const Thema: React.FC = () => {
  // 画像用のアニメーション
  const { ref: image1Ref, isVisible: isImage1Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: image2Ref, isVisible: isImage2Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  const { ref: bg0Ref, isVisible: isBg0Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg1Ref, isVisible: isBg1Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg2Ref, isVisible: isBg2Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg3Ref, isVisible: isBg3Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg4Ref, isVisible: isBg4Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg5Ref, isVisible: isBg5Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg6Ref, isVisible: isBg6Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg7Ref, isVisible: isBg7Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg8Ref, isVisible: isBg8Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg9Ref, isVisible: isBg9Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg10Ref, isVisible: isBg10Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg11Ref, isVisible: isBg11Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg12Ref, isVisible: isBg12Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg13Ref, isVisible: isBg13Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg14Ref, isVisible: isBg14Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg15Ref, isVisible: isBg15Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <div className={Styles.thema}>
      <div className={Styles.thema__inner}>
        <Title tag="h2" subTitle="THEMA" align="center" className={Styles.thema__inner__title}>
          “ドカタノシミ”
        </Title>
        <div className={Styles.thema__inner__content}>
          <div className={Styles.thema__inner__content__images}>
            <div
              ref={image1Ref}
              className={`${Styles.thema__inner__content__images__image1} ${isImage1Visible ? Styles['thema__inner__content__images__image1--visible'] : ''}`}
            >
              <picture>
                <source media="(min-width: 768px)" srcSet="/images/2025/po01.png" />
                <img src="/images/2025/po01.png" width={272} height={365} alt="人物" />
              </picture>
            </div>
            <div
              ref={image2Ref}
              className={`${Styles.thema__inner__content__images__image2} ${isImage2Visible ? Styles['thema__inner__content__images__image2--visible'] : ''}`}
            >
              <picture>
                <source media="(min-width: 768px)" srcSet="/images/2025/po02.png" />
                <img src="/images/2025/po02.png" width={204} height={288} alt="人物" />
              </picture>
            </div>
          </div>
          <div className={Styles.thema__inner__content__text}>
            <h2>
              <span>THEMA</span>
              <strong>“ドカタノシミ”</strong>
            </h2>
            <p>
              強烈なインパクトとエネルギーに満ちた一日へ。
              <br />
              <br />
              「ドカっと」した感動や喜びを体験してほしい。記憶に残る、最高の盛り上がりを見せる文化祭になることを願ったテーマです。
            </p>
          </div>
        </div>
      </div>
      <div className={Styles.thema__bg}>
        <div
          ref={bg0Ref}
          className={`${Styles.thema__bg__0} ${isBg0Visible ? Styles['thema__bg__0--visible'] : ''}`}
        >
          <svg
            width="649"
            height="601"
            viewBox="0 0 649 601"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="bg0Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="19.15%" stopColor="#5188FF" />
                <stop offset="84.95%" stopColor="#0946F1" />
              </linearGradient>
            </defs>
            <rect
              width="559.825"
              height="489.339"
              rx="60.1042"
              transform="matrix(0.957846 0.287281 0.287281 -0.957846 -14 454.712)"
              fill="url(#bg0Gradient)"
            />
          </svg>
        </div>
        <div
          ref={bg1Ref}
          className={`${Styles.thema__bg__1} ${isBg1Visible ? Styles['thema__bg__1--visible'] : ''}`}
        >
          <svg
            width="1002"
            height="677"
            viewBox="0 0 1002 677"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="481.513" cy="77.513" r="7.51302" fill="#3172F8" />
            <rect
              x="582"
              y="224.214"
              width="451.983"
              height="54.0938"
              rx="27.0469"
              transform="rotate(-29.7401 582 224.214)"
              fill="#F1ECE6"
            />
            <circle cx="654.556" cy="136.278" r="15.5556" fill="#F6B8DF" />
            <circle cx="680.528" cy="160.306" r="32.2222" stroke="#F6B8DF" strokeWidth="2.5" />
            <circle cx="680.528" cy="117.528" r="6.52778" fill="white" />
            <rect
              y="583.214"
              width="451.983"
              height="54.0938"
              rx="27.0469"
              transform="rotate(-29.7401 0 583.214)"
              fill="#F1ECE6"
            />
            <circle cx="429.721" cy="598.721" r="69.7208" fill="#F6B8DF" />
            <path
              d="M415.7 10.2632C416.426 9.50199 417.703 10.1155 417.562 11.1585L416.357 20.1001C416.294 20.5665 416.539 21.0204 416.963 21.2243L425.095 25.1333C426.043 25.5893 425.854 26.9926 424.819 27.1813L415.943 28.7985C415.48 28.8828 415.123 29.2557 415.061 29.7222L413.856 38.6638C413.715 39.7068 412.322 39.9606 411.823 39.0342L407.542 31.0921C407.318 30.6778 406.854 30.4544 406.391 30.5388L397.514 32.156C396.479 32.3446 395.807 31.0981 396.534 30.3369L402.764 23.8112C403.089 23.4708 403.158 22.9598 402.935 22.5455L398.654 14.6034C398.155 13.677 399.132 12.6528 400.081 13.1088L408.213 17.0178C408.637 17.2217 409.144 17.1293 409.469 16.7889L415.7 10.2632Z"
              fill="#5281C7"
            />
            <rect
              x="645"
              y="349.61"
              width="299.576"
              height="35.8535"
              rx="17.9268"
              transform="rotate(-29.7401 645 349.61)"
              fill="#063986"
            />
            <rect
              x="269"
              y="660.688"
              width="152.577"
              height="18.2606"
              rx="9.1303"
              transform="rotate(-29.7401 269 660.688)"
              fill="white"
            />
            <rect
              x="324"
              y="159.689"
              width="152.577"
              height="18.2606"
              rx="9.1303"
              transform="rotate(-29.7401 324 159.689)"
              fill="#3172F8"
            />
          </svg>
        </div>
        <div
          ref={bg2Ref}
          className={`${Styles.thema__bg__2} ${isBg2Visible ? Styles['thema__bg__2--visible'] : ''}`}
        >
          <svg
            width="103"
            height="103"
            viewBox="0 0 103 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="51.5"
              cy="51.5"
              r="49.5768"
              stroke="#063986"
              strokeWidth="3.84647"
              strokeDasharray="7.69 7.69"
            />
          </svg>
        </div>
        <div
          ref={bg3Ref}
          className={`${Styles.thema__bg__3} ${isBg3Visible ? Styles['thema__bg__3--visible'] : ''}`}
        >
          <svg
            width="121"
            height="147"
            viewBox="0 0 121 147"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.8162 0.995938C29.858 0.0372442 31.518 0.9718 31.2386 2.35977L28.8438 14.2587C28.7189 14.8795 29.0078 15.51 29.5596 15.8207L40.1361 21.7753C41.3698 22.4699 40.994 24.3374 39.5876 24.5006L27.531 25.8999C26.902 25.9729 26.3916 26.4426 26.2667 27.0633L23.8718 38.9623C23.5925 40.3503 21.7003 40.5699 21.1104 39.2828L16.0538 28.2487C15.7901 27.6731 15.1856 27.3328 14.5567 27.4058L2.50005 28.8052C1.09369 28.9684 0.300086 27.2366 1.34191 26.2779L10.2734 18.0591C10.7393 17.6304 10.8762 16.9504 10.6124 16.3748L5.55584 5.34065C4.96601 4.05356 6.36778 2.76365 7.60149 3.45823L18.178 9.41285C18.7298 9.72347 19.4188 9.6435 19.8847 9.21476L28.8162 0.995938Z"
              fill="#F6B8DF"
            />
            <path
              d="M102.429 81.414C102.544 81.3066 102.729 81.4088 102.699 81.5632L98.1157 105.332C98.0243 105.805 98.2487 106.284 98.671 106.518L119.859 118.222C119.997 118.298 119.957 118.506 119.801 118.525L95.7787 121.511C95.3001 121.57 94.9141 121.931 94.8228 122.405L90.2392 146.173C90.2095 146.328 89.9992 146.354 89.9326 146.212L79.6699 124.288C79.4653 123.851 79.003 123.596 78.5245 123.655L54.5022 126.64C54.3462 126.66 54.2564 126.468 54.3712 126.36L72.0505 109.826C72.4028 109.496 72.5031 108.977 72.2986 108.541L62.036 86.6165C61.9695 86.4742 62.1243 86.3295 62.2619 86.4055L83.4511 98.1102C83.8733 98.3432 84.3975 98.2779 84.7498 97.9484L102.429 81.414Z"
              fill="white"
              stroke="#1549B6"
              strokeWidth="0.951418"
            />
          </svg>
        </div>
        <div
          ref={bg4Ref}
          className={`${Styles.thema__bg__4} ${isBg4Visible ? Styles['thema__bg__4--visible'] : ''}`}
        >
          <svg
            width="749"
            height="452"
            viewBox="0 0 749 452"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="-9"
              y="414.151"
              width="853.012"
              height="54.0938"
              rx="27.0469"
              transform="rotate(-29.7401 -9 414.151)"
              fill="url(#paint0_linear_5237_488)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5237_488"
                x1="-9"
                y1="441.198"
                x2="844.012"
                y2="441.198"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0007D2" />
                <stop offset="1" stopColor="white" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg5Ref}
          className={`${Styles.thema__bg__5} ${isBg5Visible ? Styles['thema__bg__5--visible'] : ''}`}
        >
          <svg
            width="2924"
            height="1579"
            viewBox="0 0 2924 1579"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="2884.86"
              height="799.737"
              rx="130.946"
              transform="matrix(0.95195 0.306255 0.306255 -0.95195 -33.4355 728.382)"
              fill="url(#paint0_linear_5237_491)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5237_491"
                x1="824.069"
                y1="722.789"
                x2="1099.38"
                y2="-258.686"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#5188FF" />
                <stop offset="1" stopColor="#0946F1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg6Ref}
          className={`${Styles.thema__bg__6} ${isBg6Visible ? Styles['thema__bg__6--visible'] : ''}`}
        >
          <svg
            width="1867"
            height="1147"
            viewBox="0 0 1867 1147"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="-33"
              y="1018.87"
              width="2120.42"
              height="185.36"
              rx="92.68"
              transform="rotate(-29.7401 -33 1018.87)"
              fill="url(#paint0_linear_2262_285)"
            />
            <rect
              x="1111.84"
              y="680.661"
              width="744.689"
              height="89.125"
              rx="44.5625"
              transform="rotate(-29.7401 1111.84 680.661)"
              fill="url(#paint1_linear_2262_285)"
            />
            <rect
              x="1224.84"
              y="676.616"
              width="665.98"
              height="116.57"
              rx="58.2848"
              transform="rotate(-29.7401 1224.84 676.616)"
              fill="url(#paint2_linear_2262_285)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_2262_285"
                x1="-33"
                y1="1111.55"
                x2="2087.42"
                y2="1111.55"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0007D2" />
                <stop offset="1" stopColor="white" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_2262_285"
                x1="1111.84"
                y1="725.223"
                x2="1856.52"
                y2="725.223"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4D83FE" />
                <stop offset="1" stopColor="#003078" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_2262_285"
                x1="1224.84"
                y1="734.901"
                x2="1890.82"
                y2="734.901"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#4A81FE" />
                <stop offset="1" stopColor="white" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg7Ref}
          className={`${Styles.thema__bg__7} ${isBg7Visible ? Styles['thema__bg__7--visible'] : ''}`}
        >
          <svg
            width="237"
            height="237"
            viewBox="0 0 237 237"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="118.5"
              cy="118.5"
              r="116.577"
              stroke="white"
              strokeWidth="3.84647"
              strokeDasharray="7.69 7.69"
            />
          </svg>
        </div>
        <div
          ref={bg8Ref}
          className={`${Styles.thema__bg__8} ${isBg8Visible ? Styles['thema__bg__8--visible'] : ''}`}
        ></div>
        <div
          ref={bg9Ref}
          className={`${Styles.thema__bg__9} ${isBg9Visible ? Styles['thema__bg__9--visible'] : ''}`}
        ></div>
        <div
          ref={bg10Ref}
          className={`${Styles.thema__bg__10} ${isBg10Visible ? Styles['thema__bg__10--visible'] : ''}`}
        ></div>
        <div
          ref={bg11Ref}
          className={`${Styles.thema__bg__11} ${isBg11Visible ? Styles['thema__bg__11--visible'] : ''}`}
        ></div>
        <div
          ref={bg12Ref}
          className={`${Styles.thema__bg__12} ${isBg12Visible ? Styles['thema__bg__12--visible'] : ''}`}
        ></div>
        <div
          ref={bg13Ref}
          className={`${Styles.thema__bg__13} ${isBg13Visible ? Styles['thema__bg__13--visible'] : ''}`}
        ></div>
        <div
          ref={bg14Ref}
          className={`${Styles.thema__bg__14} ${isBg14Visible ? Styles['thema__bg__14--visible'] : ''}`}
        ></div>
        <div
          ref={bg15Ref}
          className={`${Styles.thema__bg__15} ${isBg15Visible ? Styles['thema__bg__15--visible'] : ''}`}
        ></div>
      </div>
    </div>
  );
};

export default Thema;
